import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import { getDataFromAPI } from "../../../../HandleAPICalls/actions";
import { toastr } from "react-redux-toastr";
import CorporateListComponent from "./component";
import { useNavigate } from "react-router-dom";

const CorporateListContainer = (props) => {
  const navigate = useNavigate();
  const [corporateList, setCorporateList] = useState([]);
  const [filteredCorporateList, setFilteredCorporateList] = useState([]);
  const [searchValue, setSearchValue] = useState("");
  const [loading, setLoading] = useState(true);
  const [pageNumber, setPageNumber] = useState(0);
  const [hasMore, setHasMore] = useState(true);
  const [isLoadingMore, setIsLoadingMore] = useState(false);

  const tableContainerRef = useRef(null);

  const handleSearchInputChange = (event) => {
    const inputValue = event.target.value;
    setSearchValue(inputValue);
  };

  const handleCreateCorporate = () => {
    navigate("/home/customermanager/create-corporate");
  };
 const handleAddNewCorporate=()=>{
    navigate("/home/customermanager/createcorporate")
  }
  // ============ TAG CONFIGURATION (with pgid) ============
  const handleTagConfiguration = (corporateId, corporateName, pgid) => {
    console.log("Navigating to Tag Dashboard for:", corporateId, corporateName, "PGID:", pgid);
    
    // Navigate with pgid in state
    navigate(`/home/walletandtags/tagpay-dashboard/${corporateId}`, {
      state: { 
        corporateName: corporateName, 
        corporateId: corporateId,
        pgid: pgid || "11"  // Default pgid for Tag Pay
      }
    });
  };

  // ============ BP CONFIGURATION (without pgid) ============
  const handleBPConfiguration = (corporateId, corporateName) => {
    console.log("Navigating to BP Dashboard for:", corporateId, corporateName);
    
    // Navigate without pgid
    navigate(`/home/customermanager/corporatedashboard/${corporateId}`, {
      state: { 
        corporateName: corporateName, 
        corporateId: corporateId 
      }
    });
  };

  // ============ EDIT CORPORATE ============
  const handleEditCorporate = (corporateId) => {
    console.log("Editing corporate details for:", corporateId);
    navigate(`/home/customermanager/editcorporatedetails/${corporateId}`);
  };

  useEffect(() => {
    handleFilterCorporate();
  }, [searchValue, corporateList]);

  // Handle infinite scroll
  useEffect(() => {
    const handleScroll = () => {
      const container = tableContainerRef.current;
      if (container && !isLoadingMore && hasMore) {
        const { scrollTop, clientHeight, scrollHeight } = container;
        if (scrollTop + clientHeight >= scrollHeight - 100) {
          loadMoreCorporates();
        }
      }
    };

    const container = tableContainerRef.current;
    if (container) {
      container.addEventListener("scroll", handleScroll);
    }

    return () => {
      if (container) {
        container.removeEventListener("scroll", handleScroll);
      }
    };
  }, [isLoadingMore, hasMore]);

  useEffect(() => {
    handleGetCorporates();
  }, []);

  const loadMoreCorporates = () => {
    if (!isLoadingMore && hasMore) {
      handleGetCorporates(true);
    }
  };

  const handleGetCorporates = (isLoadMore = false) => {
    if (isLoadMore) {
      setIsLoadingMore(true);
    } else {
      setLoading(true);
      setPageNumber(0);
      setCorporateList([]);
    }

    const currentPage = isLoadMore ? pageNumber + 1 : 0;

    props.getDataFromAPI(
      `/partner/api/v2/corporates?page=${currentPage}&size=20`,
      "GET",
      undefined,
      (response) => {
        let corporateData = [];
        let totalPages = 0;
        let currentPageNumber = 0;

        if (response?.data?.content && Array.isArray(response.data.content)) {
          corporateData = response.data.content;
          totalPages = response.data.totalPages || 0;
          currentPageNumber = response.data.number || 0;
        } else if (response?.content && Array.isArray(response.content)) {
          corporateData = response.content;
          totalPages = response.totalPages || 0;
          currentPageNumber = response.number || 0;
        } else if (Array.isArray(response)) {
          corporateData = response;
        } else if (response?.data && Array.isArray(response.data)) {
          corporateData = response.data;
        }

        const formattedCorporates = corporateData.map(corp => ({
          corporateId: corp.corporateId,
          corporateName: corp.corporateName,
          totalUsers: corp.totalUsers || 0,
          totalDepartments: corp.totalDepartments || 0,
          totalRules: corp.totalRules || 0,
          totalTags: corp.totalTags || 0,
        }));

        if (isLoadMore) {
          setCorporateList(prevList => [...prevList, ...formattedCorporates]);
          setPageNumber(currentPageNumber);
        } else {
          setCorporateList(formattedCorporates);
          setPageNumber(currentPageNumber);
        }

        setHasMore(currentPageNumber + 1 < totalPages);
        setLoading(false);
        setIsLoadingMore(false);
      },
      (err) => {
        console.log("Error fetching corporates:", err);
        toastr.error("Failed", "Unable to fetch corporate list");
        setLoading(false);
        setIsLoadingMore(false);
      }
    );
  };

  const handleFilterCorporate = () => {
    if (!searchValue.trim()) {
      setFilteredCorporateList(corporateList);
      return;
    }

    const filteredList = corporateList.filter((corporate) => {
      const searchString = searchValue.toLowerCase();
      const corporateId = (corporate.corporateId || "").toString().toLowerCase();
      const corporateName = (corporate.corporateName || "").toLowerCase();
      return corporateId.includes(searchString) || corporateName.includes(searchString);
    });
    setFilteredCorporateList(filteredList);
  };

  return (
    <CorporateListComponent
      filteredCorporateList={filteredCorporateList}
      tableContainerRef={tableContainerRef}
      handleSearchInputChange={handleSearchInputChange}
      handleFilterCorporate={handleFilterCorporate}
      handleCreateCorporate={handleCreateCorporate}
      handleTagConfiguration={handleTagConfiguration}
      handleBPConfiguration={handleBPConfiguration}
      handleEditCorporate={handleEditCorporate}
      loading={loading}
      searchValue={searchValue}
      hasMore={hasMore}
      isLoadingMore={isLoadingMore}
      handleAddNewCorporate={handleAddNewCorporate}
    />
  );
};

function mapStateToProps(state) {
  return {
    props: state,
  };
}

export default connect(mapStateToProps, {
  getDataFromAPI,
})(CorporateListContainer);